import { escapeRegExp } from "lodash/fp";

export const buildColumnExpression = (column: string) => new RegExp(`^${escapeRegExp(column)}$`, "i");
